// src/api/axiosConfig.js
import axios from "axios";

let csrfToken = null;

// Crear instancia de Axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Permite el envío de cookies
});

// Función para establecer el token CSRF
export const setCsrfToken = (token) => {
  csrfToken = token;
  axiosInstance.defaults.headers["X-CSRF-Token"] = token;
};

// Función para verificar si una ruta está excluida de CSRF
const isCsrfExcluded = (url) => {
  return (
    url.startsWith("/auth/login") ||
    url.startsWith("/auth/register") ||
    url.startsWith("/csrf-token") // Opcional, ya que /csrf-token ahora está protegida
  );
};

// Interceptor para agregar tokens de autenticación y CSRF
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Verificar si la ruta está excluida de CSRF
  const url = config.url || "";
  if (!isCsrfExcluded(url) && csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }

  return config;
});

// Interceptor para manejar refresh de token y obtener nuevo CSRF token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Solicitar refresh de token utilizando axiosInstance para incluir CSRF token si no está excluida
        const response = await axiosInstance.post("/auth/refresh", {});

        const newToken = response.data.accessToken;
        localStorage.setItem("token", newToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // Obtener nuevo CSRF token
        const csrfRes = await axiosInstance.get("/csrf-token");
        const newCsrfToken = csrfRes.data.csrfToken;
        setCsrfToken(newCsrfToken);

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
